import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Link, Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography, useTheme, } from "@mui/material";
import { StyledTableCell, TableRowsLoader, } from "../../mui-table/mui-table-helper";
import { useTranslation } from "react-i18next";
import "./RecentOfferTable.scss";
import React from "react";
import { convertToNLEuroFormat, convertUTCDateToLocalDateString, } from "../../../../application/common/utils/helper";
import { useNavigate } from "react-router-dom";
export const RecentOfferTable = ({ recentOffers, loading, }) => {
    const theme = useTheme();
    const { t: translate } = useTranslation();
    const navigate = useNavigate();
    const columns = [
        { id: "Lead #", label: "Lead #", minWidth: 150, align: "left" },
        {
            id: "Klantnaam",
            label: "Klantnaam",
            minWidth: 150,
            align: "left",
        },
        {
            id: "Telefoon",
            label: "Telefoon",
            minWidth: 150,
            align: "left",
        },
        {
            id: "Verzonden",
            label: "Verzonden",
            minWidth: 150,
            align: "left",
        },
        {
            id: "Follow-up",
            label: "Follow-up",
            minWidth: 150,
            align: "left",
        },
        {
            id: "Amount",
            label: "Amount",
            minWidth: 150,
            align: "left",
        },
        {
            id: "action",
            label: "",
            minWidth: 150,
            align: "left",
        },
    ];
    return (_jsxs(Box, { className: "recent-ofer-table-container", children: [_jsx(Box, { className: "header", children: _jsx(Typography, { sx: { color: theme.palette.text.disabled }, variant: "body1", children: "Recente offertes" }) }), _jsx(Paper, { sx: { width: "100%", overflow: "hidden", boxShadow: "none" }, children: _jsx(TableContainer, { children: _jsxs(Table, { className: "table", stickyHeader: true, "aria-label": "sticky table", children: [_jsx(TableHead, { children: _jsx(TableRow, { sx: { backgroundColor: theme.palette.common.white }, children: columns.map((column) => (_jsx(StyledTableCell, { align: column.align, style: { minWidth: column.minWidth }, children: _jsx(Typography, { className: "table-header", sx: { color: theme.palette.text.secondary }, children: translate(`${column.label}`) }) }, column.id))) }) }), _jsx(TableBody, { children: loading ? _jsx(TableRowsLoader, { rowsNum: 5, cellNum: 7 }) : (recentOffers !== null && recentOffers !== void 0 ? recentOffers : []).map((row, index) => (_jsxs(TableRow, { sx: { backgroundColor: theme.palette.common.white }, children: [_jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: row.leadNumber }) }, `${row.leadNumber} - ${index}`), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: row.clientName }) }, `${row.clientName} - ${index}`), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: row.phoneNumber }) }, `${row.phoneNumber} - ${index}`), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: convertUTCDateToLocalDateString(row.sentDate) }) }, `${row.sentDate} - ${index}`), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", children: row.followUpDate ? convertUTCDateToLocalDateString(row.followUpDate) : 'Vrij te plannen' }) }, `${row.followUpDate} - ${index}`), _jsx(StyledTableCell, { align: "left", children: _jsx(Typography, { variant: "body2", sx: {
                                                    color: '#2AA241',
                                                    fontWeight: 'bold'
                                                }, children: convertToNLEuroFormat(row.totalAmount) }) }, `${row.totalAmount} - ${index}`), _jsx(StyledTableCell, { align: "left", children: _jsx(Link, { sx: { cursor: "pointer" }, onClick: () => navigate(`/contract?contractId=${row.contractId}`), children: _jsx(Typography, { variant: "body2", sx: {
                                                        color: '#005892'
                                                    }, children: "View Details" }) }) }, `${row} - ${index}`)] }))) })] }) }) })] }));
};
